import {Component, Input, ElementRef, EventEmitter, Output} from '@angular/core';
import {Platform, DomController} from 'ionic-angular';

@Component({
    selector: 'content-drawer',
    templateUrl: 'content-drawer.html'
})
export class ContentDrawer {

    @Input('options') options: any;

    @Output('didBounce') didBounce: EventEmitter<any> = new EventEmitter();
    @Output('didBounceTop') didBounceTop: EventEmitter<any> = new EventEmitter();
    @Output('didBounceBottom') didBounceBottom: EventEmitter<any> = new EventEmitter();

    handleHeight: number = 0;
    bounceBack: boolean = true;
    thresholdTop: number = 0;
    thresholdBottom: number = 0;
    show: boolean = false;
    startY: number = 0;

    constructor(public element: ElementRef, public domCtrl: DomController, public platform: Platform) {

    }

    ngAfterViewInit() {

        this.handleHeight = this.options.handleHeight || this.handleHeight;
        this.bounceBack = this.options.bounceBack || this.bounceBack;
        this.thresholdBottom = this.options.thresholdFromBottom || this.thresholdBottom;
        this.thresholdTop = this.options.thresholdFromTop || this.thresholdTop;

        this.element.nativeElement.style.top = (this.platform.height() - this.handleHeight) + 'px';
        //this.element.nativeElement.style['padding-top'] = this.handleHeight + 'px';

        let hammer = new window['Hammer'](this.element.nativeElement);
        hammer.get('pan').set({
            direction: window['Hammer'].DIRECTION_VERTICAL
        });

        // angulos pan
        //-135 -90 -45
        //180       0
        // 135 90  45

        hammer.on('pan', (ev) => {
            if ((ev.angle >= 45 && ev.angle <= 135) || (ev.angle >= -135 && ev.angle <= -45)) {
                this.handlePan(ev);
            }
        });

        if (this.options.show) {
            this.domCtrl.write(() => {
                this.element.nativeElement.style.transition = 'top 0.3s';
                this.element.nativeElement.style.top = '0px';
            });
        }

    }

    handlePan(ev) {

        if (this.options.show) {
            //return;
        }

        if (!this.startY) {
            this.startY = ev.center.y;
        }

        let newTop = ev.center.y - this.startY;

        let bounceToTop = false;
        let bounceToBottom = false;

        if (this.bounceBack && ev.isFinal) {

            let topDiff = newTop - this.thresholdTop;
            let bottomDiff = (this.platform.height() - this.thresholdBottom) - newTop;

            topDiff >= bottomDiff ? bounceToBottom = true : bounceToTop = true;

        }

        if (bounceToTop) { //(newTop < this.thresholdTop && ev.additionalEvent == "panup") ||

            this.domCtrl.write(() => {
                this.element.nativeElement.style.transition = 'top 0.3s';
                this.element.nativeElement.style.top = '0px';
            });

            this.startY = 0;

            setTimeout(() => {
                this.didBounce.emit();
                this.didBounceTop.emit();
            }, 500);

        } else if (bounceToBottom) { //((this.platform.height() - newTop) < this.thresholdBottom && ev.additionalEvent == "pandown") ||

            this.domCtrl.write(() => {
                this.element.nativeElement.style.transition = 'top 0.3s';
                this.element.nativeElement.style.top = this.platform.height() + 'px';
            });

            this.startY = 0;

            setTimeout(() => {
                this.didBounce.emit();
                this.didBounceBottom.emit();
            }, 500);

        } else {

            this.element.nativeElement.style.transition = 'none';

            if (newTop > 0 && newTop < (this.platform.height() - this.handleHeight)) {

                if (ev.additionalEvent == "panup" || ev.additionalEvent == "pandown") {

                    this.domCtrl.write(() => {
                        this.element.nativeElement.style.top = newTop + 'px';
                    });

                }

            }

        }

    }

}



// WEBPACK FOOTER //
// ./src/components/content-drawer/content-drawer.ts